import { Button, Typography } from "components/atoms";
import { BackIcon } from "components/atoms/Icon";
import { useNavigate } from "react-router-dom";
import { decodeToken } from "utils/functions/decodeToken";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const SelfPacedUnlockMobile = ({ theme }: IProps) => {
  const navigate = useNavigate();

  const payload = decodeToken();

  const testType = payload ? payload.testtype : null;

  const handleBack = () => {
    navigate(-1);
  };

  const handleUpgrade = () => {
    if (payload && payload.hasOwnProperty("freeToPaidUpgradeLink")) {
      window.open(payload.freeToPaidUpgradeLink, "__blank");
    }
  };

  return (
    <div className="self-paced-unlock-mobile-wrapper">
      <div className="back-section">
        <div className="back-icon">
          <BackIcon
            color={theme === "light" ? "#273E5A" : "#329EE2"}
            onClickHandle={handleBack}
          />
        </div>
        <div className="back-text">
          <Typography label="Back" variant="h6Medium" onClick={handleBack} />
        </div>
      </div>
      <div className="self-paced-unlock-body-section">
        <Typography
          label={`Unlock ${testType} Self-Paced`}
          variant="h6Bold"
          styles="title-custom-style"
        />
        <Typography
          label="You must upgrade in order to gain access to all locked content."
          variant="h7Med"
          styles="sub-title-custom-style"
        />
        <Button
          icon={false}
          type="score"
          label="Upgrade Self-Paced Course"
          styles="unlock-btn-custom-style"
          onClick={handleUpgrade}
        />
      </div>
    </div>
  );
};
